// extracted by mini-css-extract-plugin
export default {"container":"FZ-z","heading":"GZ-z","links":"HZ-z","copy":"IZ-z","subCopy":"JZ-z","linksLeft":"KZ-z","linksCenter":"LZ-z","linksRight":"MZ-z","link":"NZ-z","onlyLink":"OZ-z"};